import { ListBoxContainer, ReactIcons, Switch } from "@kalyzee/kalyzee-ui"
import { MeetingContainerAPI, useMeetingSelector } from "@kalyzee/kast-web-sdk";
import MeetingSessionMediaPlayer from "../player/MeetingSessionMediaPlayer";

import workBoxStyles from "./WorkBox.module.css";
import { useMemo } from "react";
import { Video } from "@kalyzee/kast-web-sdk/web-components";
import { useBoardMedia } from "../../hooks/board";
import { LocalOrRemoteMedia } from "../../hooks/ovenmedia";
import { Meeting } from "@kalyzee/kast-web-sdk/websocket";
import { MasterPlayerWorkBox } from "./MasterPlayerWorkBox";

import styles from "./BoardInputsWorbox.module.css";
import { useAppStoreSelector } from "../../contexts/appStore/selectors";
import { useAppStoreDispatch } from "../../contexts/appStore/context";
import clsx from "clsx";

export interface InputsWorkBoxProps {
  meetingAPI: MeetingContainerAPI;
}

export const BoardInputsWorkBox = ({
  meetingAPI,
}: InputsWorkBoxProps) => {
  const [meeting] = useMeetingSelector(meetingAPI, "meeting");
  const [sessions] = useMeetingSelector(meetingAPI, "sessions");

  const dispatch = useAppStoreDispatch();
  const meetingOptions = useAppStoreSelector((state) => state.meetingOptions);

  const inputs = useBoardMedia(meetingAPI);

  const inputItems = useMemo(() => {
    if (!meeting || !inputs) return [];
    const options = meetingOptions[meeting.id] ?? {};

    const onSelectInputItem = (sessionId: string) => {
      const selectedSessions = options.disabledVideoSessionIds ?? [];
      const index = selectedSessions.indexOf(sessionId);
      if (index === -1) {
        dispatch("updateMeetingOptions", {
          meetingId: meeting.id,
          options: {
            disabledVideoSessionIds: [...selectedSessions, sessionId],
          },
        });
      } else {
        dispatch("updateMeetingOptions", {
          meetingId: meeting.id,
          options: {
            disabledVideoSessionIds: selectedSessions.filter((s) => s !== sessionId),
          },
        });
      }
    };

    const data = inputs.map((input) => {
      const mediaSessionId = input.mediaSession.id;
      const isSelected = !options?.disabledVideoSessionIds?.includes(mediaSessionId);
      return {
        input,
        selected: isSelected,
        onSelect: () => onSelectInputItem(mediaSessionId),
      };
    });

    return data;
  }, [meeting, meetingOptions, inputs]);
  
  const renderLocalOrRemoteInput = (
    meeting: Meeting,
    input: LocalOrRemoteMedia,
    selected: boolean,
  ) => {
    return (
      input.type === "remote" ? (
        <MeetingSessionMediaPlayer
          meeting={meeting}
          sessions={sessions ?? []}
          sessionId={input.session.id}
          mediaSessionId={input.mediaSession.id}
          ovenMediaSession={input.videoSession}
          muted={true}
          style={{
            overflow: "hidden",
            width: "100%",
            height: "100%",
          }}
          videoStyle={{
            objectFit: "cover",
          }}
        />
      ) : (
        <div style={{
          overflow: "hidden",
          position: "relative",
          width: "100%",
          height: "100%",
        }}>
          <Video
            style={{ objectFit: "cover", width: "100%" }}
            src={input.stream}
            autoPlay
            muted
          />
          <div style={{
            position: "absolute",
            bottom: 10,
            left: 10,
            color: "white",
            fontSize: "0.75em",
            backgroundColor: "#00000088",
            padding: "2px 5px",
            borderRadius: 5,
            
          }}>
            local-stream
          </div>
        </div>
      )
    );
  }

  const renderItems = () => {
    if (!meeting) return [];
    return inputItems.map((inputItem) => {
      const input = inputItem.input;
      return (
        <MasterPlayerWorkBox
          meetingAPI={meetingAPI}
          session={input.session}
          mediaSession={input.mediaSession}
          extraHeaderContent={
            <Switch
              value={inputItem.selected}
              switchNativeProps={{ disabled: true }}
              className={styles.switch}
            />
          }
          className={clsx({
            [styles.inputContainer]: true,
            [styles.selected]: inputItem.selected,
          })}
          topBarClassName={styles.inputTopBar}
          nativeProps={{
            onClick: inputItem.onSelect,
            style: {
              aspectRatio: "3 / 1",
            }
          }}
          overlayMode="overlay"
        >
          {renderLocalOrRemoteInput(meeting, input, inputItem.selected)}
        </MasterPlayerWorkBox>
      );
    });
  }

  return (
    <ListBoxContainer
      style={{ width: "100%", height: "100%" }}
      topBarProps={{
        center: [
          <ReactIcons.PlayScreens style={{ width: 31 }} />,
          <span className={workBoxStyles.label}>Affichage</span>
        ],
      }}
      items={renderItems()}
    />
  );
}